module.exports = __webpack_public_path__ + "media/flags/id-f6d0e03c.svg";